import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramById } from "services";

import { GET_CARBON_PROGRAM_BY_ID } from "consts";

import { CarbonProgram } from "models";

export const useGetCarbonProgramById = ({ programId }: { programId?: string }) =>
  useQuery<CarbonProgram | null>({
    queryKey: [GET_CARBON_PROGRAM_BY_ID, programId],
    queryFn: () => (programId ? getCarbonProgramById(programId) : null),
    enabled: !!programId,
  });
